var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21967 0.219548C3.51256 -0.0733454 3.98744 -0.0733454 4.28033 0.219548L10.2803 6.21955C10.5732 6.51244 10.5732 6.98731 10.2803 7.28021L4.28033 13.2802C3.98744 13.5731 3.51256 13.5731 3.21967 13.2802C2.92678 12.9873 2.92678 12.5124 3.21967 12.2195L8.68934 6.74988L3.21967 1.28021C2.92678 0.987315 2.92678 0.512441 3.21967 0.219548Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightIconWhite);
export default __webpack_public_path__ + "static/media/chevron_right_icon_white.dff6fe6373073b12f6cdbdc79b9d2a9e.svg";
export { ForwardRef as ReactComponent };